export default class eventMessageScheduler {
    constructor() {
        return {
            restrict: 'E',
            scope: {
                event: '=',
                message: '=',
                eventMessageType: '='
            },
            template: require('../../../../views/event/directives/event-message-schedule.html'),
            controller: EventMessageScheduler,
            controllerAs: 'scheduler'
        }
    }
};

class EventMessageScheduler {
    constructor($scope, $filter, $state, $stateParams, $timeout, Campaign, SweetAlert, Events, Event) {
        this._scope = $scope;
        this._translator = $filter('translate');
        this._stateParams = $stateParams;
        this._state = $state;
        this._timeout = $timeout;

        this.eventRepo = Event;
        this.alerter = SweetAlert;
        this.eventHandler = Events;
        this.campaignRepo = Campaign;
        this.eventPageData = "";

        this.schedulerType = 'draft'; // default.
        this.minimumDate = moment().format('YYYY-MM-DD');
        this.toAttenders = true;
        this.showOverlay = false;


        this.statusIdToName = {
            1: 'draft',
            2: 'current',
            3: 'completed',
            4: 'scheduled'
        };

        this.scheduler = {
            date: moment().format('YYYY-MM-DD'),
            time: {
                hour: moment().format('HH'),
                minutes: moment().format('MM'),
            },
            relativeDate: 0
        };

        this._scope.$on('event:message:showSchedule', (event, data) => {
            this.message = data['message'];
            this.eventMessageType = data['eventMessageType'];
            this.event = data['event'];
            this.invitationCampaign = this.event.campaigns.filter(campaign => campaign.pivot["event_dispatcher_type_id"] === 1);
            this.invitationScheduleDateFormatted = {};
            this.counting = true;

            this.showOverlay = true;
            this.minimumDate = this.eventMessageType == 'post' ? moment(this._scope.event.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');

            if (this.scheduler.date == null) {
                this.scheduler.date = moment(this._scope.minimumDate).format('YYYY-MM-DD');
            }

            if(this.invitationCampaign) {
                this.campaignRepo.getSchedule(this.invitationCampaign[0].id).then((schedule) => {
                    this.invitationScheduleDateFormatted = moment(schedule.date + " " + schedule.time.hour + ":" + schedule.time.minutes);
                });
            }

            this.eventRepo.find(this._scope.event.id).then((event) => {
                if (event.data.pages['episubscription'].data) {
                    this.eventPageData = angular.fromJson(event.data.pages['episubscription'].data);
                    this.publishAt = moment(this.eventPageData['metadata']['publish_at']);
                    this.hasBeenPublished = (moment() > this.publishAt);
                    this.publishDate = moment(this.publishAt).format('YYYY-MM-DD');

                    this.publishTime = {
                        hour: moment(this.publishAt).format('HH'),
                        minutes: moment(this.publishAt).format('mm')
                    };
                }
            });

                this.campaignRepo.getRecipientCount(this._scope.message.id).then(() => {
                    this.pollCount(this._scope.message.id);
                });

            if (this.message.campaign_status_id == 4) { // Check schedule.
                this.campaignRepo.getSchedule(
                    this.message.id,
                    'scheduled',
                    this.message.message_type_id,
                    'campaign'
                ).then((schedule) => {
                    this.setSchedulerType('scheduled');
                    this.scheduler.date = moment(schedule.date).format('YYYY-MM-DD');
                    this.scheduler.time = {
                        hour: +schedule.time.hour < 10 ? `0${+schedule.time.hour}` : schedule.time.hour,
                        minutes: +schedule.time.minutes < 10 ? `0${+schedule.time.minutes}` : schedule.time.minutes
                    };
                });
            }
        });
    };

    calcRelativeDate() {
        let relativeValue = this.scheduler.relativeDate;

        if (relativeValue < 0 || ! angular.isNumber(relativeValue)) {
            return this.scheduler.relativeDate = 0;
        }

        //if (angular.isNumber(relativeValue) && relativeValue >= 0) {
            let date;

            if (this.schedulerType == 'relativeAfter') {
                date = moment(this.event.start_date).add(relativeValue, 'days');
            } else {
                date = moment(this.event.start_date).subtract(relativeValue, 'days');
            }

            if (date > moment()) {
                this.scheduler.date = date.format('YYYY-MM-DD');
            }
        //} else if (relativeValue < 0) {
            //this.scheduler.relativeDate = 0;
        //}
    };

    setSchedulerType(type) {
        this.schedulerType = type;
    };

    close() {
        this.showOverlay = false;
    };

    toSchedule() {
        let type = (this.schedulerType == 'relativeBefore' || this.schedulerType == 'relativeAfter') ? 'scheduled' : this.schedulerType;
        let thisScheduleDateFormatted = moment(this.scheduler.date + " " + this.scheduler.time.hour + ":" + this.scheduler.time.minutes);
        let eventEndDateFormatted = moment(this.event["end_date"]);

        if (this.eventMessageType != 'post' && this.eventMessageType == 'cancellation' && moment(this.scheduler.date) > moment(this.event.start_date)) {
            return this.alerter.swal({
                title: this._translator('EVENT:FLASH:SCHEDULE_ERROR'),
                text: this._translator('EVENT:SCHEDULER:SCHEDULE_AFTER_EVENT'),
                type: 'error'
            });
        }

        if(this.message.pivot["event_dispatcher_type_id"] === 3 || this.message.pivot["event_dispatcher_type_id"] === 4) {
            if(! this.eventRemindersAreCorrect()) {
                return this.alerter.swal({
                    title: this._translator('EVENT:FLASH:SCHEDULE_ERROR'),
                    text: this._translator('EVENT:SCHEDULER:SCHEDULE_INCORRECT'),
                    type: 'error'
                });
            }
        }

        if(this.message.pivot["event_dispatcher_type_id"] === 1) {
            let pagePublishAtFormatted = moment(this.publishDate + " " + this.publishTime.hour + ":" + this.publishTime.minutes);
            if(
                thisScheduleDateFormatted.diff(eventEndDateFormatted) > 0
                || thisScheduleDateFormatted.diff(pagePublishAtFormatted) < 0
                || (moment().diff(pagePublishAtFormatted) < 0 && this.schedulerType === 'now'))
            {
                return this.alerter.swal({
                    title: this._translator('EVENT:FLASH:SCHEDULE_ERROR'),
                    text: this._translator('EVENT:SCHEDULER:SCHEDULE_INCORRECT'),
                    type: 'error'
                });
            }
        }

        if(this.message.pivot["event_dispatcher_type_id"] === 3 || this.message.pivot["event_dispatcher_type_id"] === 4) {
            if(! this.eventRemindersAreCorrect()) {
                return this.alerter.swal({
                    title: this._translator('EVENT:FLASH:SCHEDULE_ERROR'),
                    text: this._translator('EVENT:SCHEDULER:SCHEDULE_REMINDERS_INCORRECT'),
                    type: 'error'
                });
            }
        }

        if(this.message.pivot["event_dispatcher_type_id"] === 5) {

            if(! this.eventSurveyCampaignIsCorrect()) {
                return this.alerter.swal({
                    title: this._translator('EVENT:FLASH:SCHEDULE_ERROR'),
                    text: this._translator('EVENT:SCHEDULER:SCHEDULE_INCORRECT'),
                    type: 'error'
                });
            }
        }

        let time = {
            hour: +this.scheduler.time.hour < 10 ? `0${+this.scheduler.time.hour}` : this.scheduler.time.hour,
            minutes: +this.scheduler.time.minutes < 10 ? `0${+this.scheduler.time.minutes}` : this.scheduler.time.minutes
        };

        let scheduleObject = {
            campaign: this.message,
            date: this.scheduler.date,
            schedulerType: type,
            time,
            messageType: 'email'
        };

        this.campaignRepo.setSchedule(scheduleObject).then(() => {
            if (this.schedulerType == 'now') {
                this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:NOW_SENDING'));
                this.message['campaign_status_id'] = 2;
            } else if (this._scope.schedulerType == 'draft') {
                this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:SAVED_AS_DRAFT'));
            } else {
                this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:SCHEDULE_CHANGED'));
            }

            this.eventRepo.find(this.event.id).then((event) => {
                if (this.statusIdToName[event.data.event_status_id] != this._stateParams.folder) {
                    if (event.data.event_status_id == 1 && ! this._stateParams.folder) {
                        // Stay in drafts
                        this.close();
                    } else {
                        this._state.go('event.folder', { folder: this.statusIdToName[event.data.event_status_id] });
                    }
                }
            });

            this._scope.$emit('event:schedule:updated');
        }, (error) => {
            this.eventHandler.flashEvent('error', this._translator('CAMPAIGN_SUMMARY_SCHEDULED:ERROR'));
        });

        this.close();
    };

    eventRemindersAreCorrect() {
        let thisScheduleDateFormatted = moment(this.scheduler.date + " " + this.scheduler.time.hour + ":" + this.scheduler.time.minutes);
        let invitationCampaign = this.event.campaigns.filter(campaign => campaign.pivot["event_dispatcher_type_id"] === 1);
        let invitationIsSent = invitationCampaign[0]["campaign_status_id"] === 3;
        let invitationIsScheduled = invitationCampaign[0]["campaign_status_id"] === 4;

        if(invitationIsScheduled) {
            let scheduledTimeIsCorrect = thisScheduleDateFormatted.diff(this.invitationScheduleDateFormatted) >= 0;
            return (invitationCampaign && (invitationIsSent || (invitationIsScheduled && scheduledTimeIsCorrect)));
        } else {
            return (invitationCampaign && invitationIsSent);
        }
    };

    eventSurveyCampaignIsCorrect() {
        let thisScheduleDateFormatted = moment(this.scheduler.date + " " + this.scheduler.time.hour + ":" + this.scheduler.time.minutes);
        let eventStartDateFormatted = moment(this.event["start_date"]);
        let episurveyPageIsPublished = this.event.pages.episurvey && this.event.pages.episurvey.published;
        let scheduledTimeIsCorrect = thisScheduleDateFormatted.diff(eventStartDateFormatted) >= 0;

        return episurveyPageIsPublished && scheduledTimeIsCorrect;
    };

    cancellationSchedule() {
        this.eventRepo.setCancellationRecipients(this.event.id, this.toAttenders).then(() => {
            this.toSchedule();
        }, function(error) {
            // Add handling here if needed..
        });
    };

    schedule() {
        this.eventMessageType == 'cancellation' ? this.cancellationSchedule() : this.toSchedule();
    };

    pollCount(campaignId) {
        this._timeout(() => {
            this.campaignRepo.pollRecipientCount(campaignId).then((response) => {
                if (response && response.state == 'finished') {
                    this.recipientCount = response['count'];
                    this.counting = false;
                } else {
                    this.pollCount(campaignId);
                }
            });
        }, 1000);
    };
};
